export default "/images/success.svg?eeeaae3fa7080a580e969c6a068a53a5";